export default `
§ uiKit.console.button: Copiar
§ uiKit.console.notification: Texto copiado
§ uiKit.dataLoader.page: Página
§ uiKit.dataLoader.size: Exibido por
§ uiKit.dataLoader.from: de
§ uiKit.dataLoader.all: Mostrar tudo
§ uiKit.hoursChart.work: Tempo de trabalho padrão. (dias de semana, das 07: 00 às 20:00)
§ uiKit.hoursChart.weekend: fins de semana ou tempo antes / depois do dia de trabalho
§ uiKit.hoursChart.days: número total de commits em um determinado dia e hora
§ uiKit.page.remove: Remover
§ uiKit.nothingFound.common.title: Não há ou não há dados suficientes para exibir
§ uiKit.nothingFound.common.description: O sistema processará mais dados se os commits forem assinados no formato [Git commit message convention|https://www.conventionalcommits.org/en/v1.0.0/]. Modelo:
§ uiKit.nothingFound.common.console: Número da tarefa_tipo(módulo): explicação
§ uiKit.nothingFound.common.example: Por exemplo:
§ uiKit.nothingFound.staff.title: Não há dados para este funcionário
§ uiKit.nothingFound.staff.description1:
Ele não fazia alterações todos os dias de trabalho. Por isso, ele recebeu o status “Assistente”.
As estatísticas de um trabalhador com esse status não precisam ser registradas. Sua influência é insignificante.
§ uiKit.nothingFound.staff.description2:
O sistema não calcula uma série de indicadores para ele.
Se este for um erro e a estatística para esse funcionário precisar ser levada em consideração, vá para a seção “Configurações” e altere o seu tipo.
§ common.title: Git estatística
§ common.filters: Filtro
§ common.notifications.save: Alterações salvas
§ common.notifications.setting: Configuração guardada
`;
